import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

export interface ParsedData {
  mimetype: string;
  data: string;
}

@Injectable({
  providedIn: "root",
})
export class DataConvertingService {
  parseEmbeddedUrlFromBase64(base64: string): ParsedData {
    const [metaData, data] = base64.split(",");
    const mimetype = metaData.split(";")[0].split(":")[1];
    return { data, mimetype };
  }
  blobToBase64(blob: Blob) {
    const subj = new Subject<string>();
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result as string;
      subj.next(base64data);
      subj.complete();
    };
    return subj.asObservable();
  }

  arrayBufferToBase64(buffer, mimetype?: string) {
    let result = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) result += String.fromCharCode(bytes[i]);

    result = btoa(result);
    if (mimetype) result = `data:${mimetype};base64,${result}`;

    return result;
  }

  blobToArrayBuffer(blob: Blob): Observable<ArrayBuffer> {
    const fileReader = new FileReader();
    const subject = new Subject<ArrayBuffer>();
    fileReader.readAsArrayBuffer(blob);
    fileReader.onload = (event: any) => {
      subject.next(event.target.result as ArrayBuffer);
      subject.complete();
    };

    fileReader.onerror = subject.error;
    return subject;
  }
}
